"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const ru_json_1 = __importDefault(require("../json/ru.json"));
const en_json_1 = __importDefault(require("../json/en.json"));
const wishlist_json_1 = __importDefault(require("../json/ru/wishlist.json"));
const auth_json_1 = __importDefault(require("../json/ru/auth.json"));
const hotel_json_1 = __importDefault(require("../json/ru/hotel.json"));
const getValuesFromBackend_1 = require("../utils/getValuesFromBackend");
const validationsData_1 = require("../utils/validationsData");
exports.resources = {
    en: { translation: en_json_1.default },
    ru: { translation: ru_json_1.default },
};
// получаем с бэка конфигурацию проекта
const { language } = (0, getValuesFromBackend_1.getLocalizationValues)();
// валидируем на поддержу текущий язык
const currentLanguage = (0, validationsData_1.validateLanguage)(language);
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    resources: exports.resources,
    lng: currentLanguage,
    interpolation: { escapeValue: false },
    returnNull: false,
});
/**
 * Идея данной фичи в том чтобы разбить наш текущий полотно файл на несколько чанков (для начала я думаю это нужно сделать постранично)
 * Это облегчит работу с самими файлами (тк очень тяжело стало искать ту или иную строчку)
 * Плюс данный подход эта некое облегчение тк присутствует разбиение на чанки
 */
i18next_1.default.addResourceBundle('ru', 'wishlist', wishlist_json_1.default);
i18next_1.default.addResourceBundle('ru', 'auth', auth_json_1.default);
i18next_1.default.addResourceBundle('ru', 'hotel', hotel_json_1.default);
exports.default = i18next_1.default;
